var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"posts-info"},[_c('a',{staticClass:"info-text category",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.category))]),_vm._v(" "),_c('div',{staticClass:"info-divider"}),_vm._v(" "),_c('div',{staticClass:"info-text"},[_vm._v(_vm._s(_vm.date))])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32973780","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blog/BlogPostInfo.vue
// module id = 333b
// module chunks = 0